export const SET_POSITION = "SET_POSITION";
export const SET_CURRENT_ACTION = "SET_CURRENT_ACTION";
export const SET_MODAL_DATA = "SET_MODAL_DATA";
export const SET_DESCRIPTIVE_DATA = "SET_DESCRIPTIVE_DATA";

export const setDescriptiveData = descriptiveData => ({
  type: "SET_DESCRIPTIVE_DATA",
  descriptiveData
});
